import React from 'react';
import cn from 'classname';
import './index.less';
import Row from './row';

function PayoutTable({ table, sort, toggleSort, ...props }) {
	const { rows, headers } = table;
	return (
		<div
			className="table-container payout-requests-register-table"
		>
			<table className="simple-table">
				<thead className="simple-table__head font-roboto-medium">
					<tr className="top-affiliates-table-top-row">
						{
							headers
								.filter(header => !props.isHiddenCopyCols || !header.isHiddenForCopy)
								.map((header, i) =>
									<th
										key={i}
										onClick={toggleSort.bind(null, header.canBeSorted && header.index)}
										className={cn({
											[header.className]: !!header.className,
											'sort-header': header.canBeSorted,
											'active': header.index === sort.index,
											'desc': sort.direction === 'desc',
											'asc': sort.direction === 'asc'
										})}
									>
										{header.title}
									</th>
								)
						}
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{rows.map((row, index) =>
						<Row row={row} key={index} index={index} {...props} />
					)}
				</tbody>
			</table>
		</div>
	);
}

export default PayoutTable;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/table-register/main.js